import { useSelector } from 'react-redux';
import selectors from '../selectors/selectors';

const stableObject = {};
const stableArray = [];

const useComposerIntegration = () => {
  const activeComposerType = useSelector(selectors.activeComposerType);
  const activeIntegration = useSelector((state) => ((state.currentServiceProvider || stableObject).platformRegistrations || stableArray).find((el) => el.id === activeComposerType.integration_id));
  return [activeComposerType, activeIntegration];
};

export default useComposerIntegration;
